import * as actionTypes from "../actions/actionTypes";

const initialState = {
  loan: null,
};

export default (state = initialState, action = {}) => {

  switch (action.type) {
    case actionTypes.LOAN_SAVE:
      return {
        ...state,
        loan: action.data,
      };

    default:
      return state;
  }
};
